import { render, staticRenderFns } from "./kami.vue?vue&type=template&id=973dc6e6&scoped=true&"
import script from "./kami.vue?vue&type=script&lang=js&"
export * from "./kami.vue?vue&type=script&lang=js&"
import style0 from "./kami.vue?vue&type=style&index=0&id=973dc6e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973dc6e6",
  null
  
)

export default component.exports